import { combineReducers } from 'redux';
import taxInputReducer from './taxProjectionDataSlice';

const rootReducer = combineReducers({
  taxProjectionDataState: taxInputReducer
});

export default rootReducer;
